import * as S from "./ChatsLogs.styles";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getMessageUserName } from "pages/HistoryPage/HistoryPage.config";
import { getDefaultId } from "utils/functions";


function ChatLogs({ item, visitorPartner }) {
  console.log(item);
  const { partnerTeam } = useSelector(({ agents })=> agents);

  const senderName = useCallback((id) => {
    return getMessageUserName(id, partnerTeam, visitorPartner);
  }, [partnerTeam, visitorPartner]);

  return (
    <S.ChatContainer>
      {item.logs?.map((log) => {
        return (
        <div key={getDefaultId()}>
          <S.ChatLogsItem>
            <S.ChatLeftItem>
              <p>{senderName(log.userId).name}</p>
              <p>{log.action}</p>
            </S.ChatLeftItem>
            {new Date(log.createdAt).toLocaleString()}
          </S.ChatLogsItem>
        </div>);
      }
      )}
    </S.ChatContainer>
  );
}

export { ChatLogs };